var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#FEE7EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3934 6.66663L10.0001 9.05996L7.60675 6.66663L6.66675 7.60663L9.06008 9.99996L6.66675 12.3933L7.60675 13.3333L10.0001 10.94L12.3934 13.3333L13.3334 12.3933L10.9401 9.99996L13.3334 7.60663L12.3934 6.66663Z",
    fill: "#E60A2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelSmall);
export default __webpack_public_path__ + "static/media/cancel-small.a0d289b121fe49759f760356a90a6114.svg";
export { ForwardRef as ReactComponent };